var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "news-card",
      attrs: {
        to: { name: "portal.news.single", params: { slug: _vm.news.slug } },
      },
    },
    [
      _c("article", [
        _c("figure", { staticClass: "news-card__figure" }, [
          _c("picture", [
            _c("img", {
              attrs: {
                loading: "lazy",
                src: _vm.thumbnail,
                alt: _vm.news.slug,
                title: _vm.news.title,
              },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "news-card__content" }, [
          _c("div", [
            _c("h2", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.news.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "subtitle" }, [
              _vm._v(_vm._s(_vm.news.subtitle)),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "time",
            {
              staticClass: "time",
              attrs: { datetime: _vm.timeSI, pubdate: "" },
            },
            [
              _c("span", { staticClass: "far fa-clock" }),
              _vm._v(
                "\n                " + _vm._s(_vm.timeText) + "\n            "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }